import { useContext } from "react";
import styled from "styled-components";
import { AppContext } from "../App";

const TopLinks = () => {
  const { setClaim, setAbout } = useContext(AppContext);

  return (
    <Wrapper>
      <button
        onClick={() => {
          setClaim((prev: boolean) => !prev);
        }}
        className="sign-up"
      >
        Claim My <span className="life-plan">Life Plan</span>
      </button>
      <button
        onClick={() => {
          setAbout((prev: boolean) => !prev);
        }}
        className="about"
      >
        What is this?{" "}
        <i className="tiny material-icons target-link">call_made</i>
      </button>
    </Wrapper>
  );
};

export default TopLinks;

const Wrapper = styled.div`
  position: absolute;
  top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 40px;
  z-index: 100;
  font-size: 16px;

  .life-plan {
    font-weight: 600;
  }

  .sign-up {
    background: #243aff;
    color: white;
  }

  button {
    padding: 10px;
    border-radius: 30px;
    color: #2339ff;
    border: transparent;
    background-color: transparent;
    cursor: pointer;
  }

  button:hover {
    border: 0.25px solid #2339ff;
  }

  @media screen and (max-width: 650px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
